export const GetEditor = (state = null, action) => {
    switch (action.type) {
        case 'GET_EDITOR':
          return action.editor;
        default:
          return state
    }
}